import * as React from "react";
import Link from "components/Link";
import { graphql, StaticQuery } from "gatsby";

import DataProvider from "providers/data";
import $ from 'jquery';

const OffCanvasNavigationHandler = (props) => (
	<StaticQuery
		query={graphql`
		{
			allContentMenu(filter: {menuID: {eq: "main"}}) {
				edges {
					node {
						pages
					}
				}
			}
		}
		`}
		render={(data) => {

			const handleAccordion = (event) => {
				event.preventDefault()
				const { target } = event
				const parent = target.parentNode;
				const siblings = parent.childNodes;
				if (parent.classList.contains("is-accordion-submenu-parent")) {
					const activeMenus = document.querySelectorAll('.menu.vertical.nested.is-active');
					if (activeMenus.length) {
						parent.classList.remove("child-active");
						let currentMenu = activeMenus[activeMenus.length - 1];
						currentMenu.classList.remove('is-active');
						$(currentMenu).slideUp();
					} else {
						parent.classList.add("child-active");
						siblings.forEach(element => {
							if (element.nodeName === "UL") {
								element.classList.add('is-active');
								$(element).slideDown();
							}
						});
					}
				}
			}

			const { edges: menuEdges } = data.allContentMenu;
			let mainMenu = menuEdges.map(({ node }) => node.pages)[0];
			if ((props.providerResponse.data.length > 0 || !!mainMenu !== false) && props.providerStatusText === "LOADED") {
				mainMenu = props.providerResponse.data.filter(datum => datum.menuID === "main")[0].pages;
			}

			return (<>
				<ul className={`vertical menu`}>
					{mainMenu.length && mainMenu.map((item, ind) => {
						let submenuLinks = []

						if (item.hasOwnProperty("children")) submenuLinks = item.children
						if (!JSON.parse(item.visible)) return null;
						return (
							<li key={`accordion-${ind}-parent`} className={`${submenuLinks.length ? "is-accordion-submenu-parent" : ""}`}>
								<Link key={`accordion-${ind}-root`} className={`faux-link`} onClick={(e) => { if (submenuLinks.length) { handleAccordion(e) } }} to={submenuLinks.length ? `#` : item.href}>{item.text}</Link>
								{submenuLinks.length > 0 &&
									<ul className={`menu vertical nested submenu is-accordion-submenu`} style={{ display: "none" }}>
										{/* <li key={`accordion-${ind}-back`} className={`js-accordion-back`}><Link onClick={(e) => { if (submenuLinks.length) { handleAccordion(e) } }} href={`#`}>Back</Link></li> */}
										<li key={`accordion-${ind}-root`}><Link to={item.href}>{item.text}</Link></li>
										{submenuLinks.map(({ text, href, visible }, index) => !visible ? null : <li key={`accordion-${index}`}><Link to={href}>{text}</Link></li>)}
									</ul>
								}
							</li>
						)
					})}
				</ul>
			</>
			)
		}}
	/>
)

const OffCanvasNavigation = (props) => {
	return (
		<DataProvider liveRefresh={true} type="ContentMenu">
			<OffCanvasNavigationHandler {...props} />
		</DataProvider>
	);
};

export default OffCanvasNavigation;